import { Injectable } from '@angular/core';

// Import mgrs library for coordinate conversion
import * as mgrsLib from 'mgrs';

@Injectable({
  providedIn: 'root'
})
export class MgrsHelperService {

  constructor() { }

  /**
   * Check if the input string is a valid MGRS coordinate
   * MGRS format: Zone + Letter + Easting + Northing
   * Example: 43P FT 12345 67890
   * @param value - Input string to check
   * @returns true if valid MGRS format
   */
  isMGRS(value: string): boolean {
    if (!value || typeof value !== 'string') {
      return false;
    }

    // Remove extra whitespace and convert to uppercase
    const normalized = value.trim().toUpperCase().replace(/\s+/g, ' ');

    // MGRS regex pattern
    // Zone: 1-2 digits (01-60)
    // Band letter: A-Z (excluding I and O)
    // Easting: 5 digits
    // Northing: 5 digits
    // Pattern: optional spaces allowed between components
    const mgrsPattern = /^\d{1,2}[C-HJ-NP-X]\s*[A-HJ-NP-Z]{2}\s*\d{5}\s*\d{5}$/;

    return mgrsPattern.test(normalized);
  }

  /**
   * Convert MGRS coordinates to latitude and longitude
   * @param mgrsString - MGRS coordinate string (e.g., "43P FT 12345 67890")
   * @returns Object with lat, lng properties, or null if conversion fails
   */
  convertMGRSToLatLng(mgrsString: string): { lat: number; lng: number } | null {
    if (!mgrsString || !this.isMGRS(mgrsString)) {
      return null;
    }

    try {
      // Normalize the input: remove extra spaces, convert to uppercase
      const normalized = mgrsString.trim().toUpperCase().replace(/\s+/g, '');

      // Use the mgrs library to convert to point [lng, lat]
      const point = (mgrsLib as any).toPoint(normalized);

      if (point && point.length >= 2) {
        return {
          lng: point[0],
          lat: point[1]
        };
      }
    } catch (error) {
      console.error('Error converting MGRS to coordinates:', error);
    }

    return null;
  }
}
